import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { MetricValue } from "@shared/metric-value";

export const PercentDataFormatter = ({
  column,
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  return <MetricValue as="span" value={row[column.name]} format="percentage" />;
};
